// client/src/lib/roles.js

export function normalizeBool(v) {
  if (v === true || v === 1) return true;
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    return s === '1' || s === 'true' || s === 'yes' || s === 'y';
  }
  return false;
}

export function normalizeRole(user) {
  const raw = (user?.access_level ?? user?.role ?? '').toString();
  return raw.trim().toLowerCase();
}

// ✅ single source of truth for create-group permission in the UI
export function canCreateGroup(user) {
  const role = normalizeRole(user);
  if (role === 'superadmin') return true;

  // IMPORTANT: do NOT fall back to approved_by_superadmin
  // because that is what caused the bug.
  return normalizeBool(user?.can_create_group);
}

// Backwards compatible name used in components
export function isApprovedOrganiser(user) {
  return canCreateGroup(user);
}
